module.exports = __webpack_public_path__ + "static/32risk-ea1496246ff608f15524439160af8a7b.png";